/* Kanela Welten: Warenkorb, Filter, Packungswahl, sanftes Einblenden */
(function () {
  if (window.kelInit) return;
  window.kelInit = true;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function toast(html) {
    var el = document.querySelector('.kel-toast');
    if (!el) {
      el = document.createElement('div');
      el.className = 'kel-toast';
      el.setAttribute('role', 'status');
      el.setAttribute('aria-live', 'polite');
      document.body.appendChild(el);
    }
    el.innerHTML = html;
    el.classList.add('is-visible');
    clearTimeout(el._t);
    el._t = setTimeout(function () { el.classList.remove('is-visible'); }, 3500);
  }

  function refreshCart() {
    if (document.querySelector('cart-drawer')) {
      /* Das Theme hört auf dieses Event, lädt den Warenkorb neu und öffnet die Schublade */
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: true } }));
      return true;
    }
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('.cart-count, .cart-count-bubble span, [data-cart-count]').forEach(function (n) { n.textContent = cart.item_count; });
      })
      .catch(function () {});
    return false;
  }

  /* Texte in der Sprache der Seite (kommen aus dem Snippet kel-assets) */
  function t(key, fallback) { var d = window.KEL_I18N || {}; return d[key] || fallback; }

  function addToCart(variantId, button) {
    if (!variantId || (button && button.getAttribute('aria-busy') === 'true')) return;
    var label = button ? button.innerHTML : '';
    if (button) { button.setAttribute('aria-busy', 'true'); button.innerHTML = t('adding', 'Wird hinzugefügt …'); }
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.data.description || res.data.message || 'Fehler');
        if (button) {
          button.classList.add('is-added');
          button.innerHTML = t('added', '✓ Im Warenkorb');
          setTimeout(function () { button.classList.remove('is-added'); button.innerHTML = label; }, 2200);
        }
        if (!refreshCart()) toast(t('inCart', 'Im Warenkorb') + ' <a href="' + root + 'cart">' + t('view', 'Ansehen') + '</a>');
      })
      .catch(function (err) {
        if (button) button.innerHTML = label;
        toast(String(err.message || t('error', 'Leider hat das nicht geklappt. Bitte versuchen Sie es nochmals.')));
      })
      .finally(function () { if (button) button.removeAttribute('aria-busy'); });
  }

  document.addEventListener('click', function (e) {
    var add = e.target.closest('[data-kel-add]');
    if (add) {
      e.preventDefault();
      addToCart(add.getAttribute('data-kel-add'), add);
      return;
    }

    var tab = e.target.closest('[data-kel-tab]');
    if (tab) {
      var scope = tab.closest('[data-kel-filter]');
      var value = tab.getAttribute('data-kel-tab');
      var shown = 0;
      scope.querySelectorAll('[data-kel-tab]').forEach(function (t) {
        var active = t === tab;
        t.classList.toggle('is-active', active);
        t.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      scope.querySelectorAll('[data-kel-tags]').forEach(function (card) {
        var tags = ' ' + card.getAttribute('data-kel-tags') + ' ';
        var match = value === 'alle' || tags.indexOf(' ' + value + ' ') > -1;
        card.hidden = !match;
        if (match) shown++;
      });
      var count = scope.querySelector('[data-kel-count]');
      if (count) count.textContent = shown + ' ' + (shown === 1 ? t('product', 'Produkt') : t('products', 'Produkte'));
      return;
    }

    var pack = e.target.closest('[data-kel-pack]');
    if (pack) {
      var tip = pack.closest('[data-kel-tip]');
      tip.querySelectorAll('[data-kel-pack]').forEach(function (p) {
        var active = p === pack;
        p.classList.toggle('is-active', active);
        p.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      var price = tip.querySelector('[data-kel-tip-price]');
      var btn = tip.querySelector('[data-kel-add]');
      var img = tip.querySelector('[data-kel-tip-img]');
      if (price) price.textContent = pack.getAttribute('data-price');
      if (btn) {
        btn.setAttribute('data-kel-add', pack.getAttribute('data-variant'));
        btn.disabled = pack.getAttribute('data-available') !== 'true';
      }
      if (img && pack.getAttribute('data-img')) {
        img.style.opacity = '0';
        setTimeout(function () { img.src = pack.getAttribute('data-img'); img.removeAttribute('srcset'); img.style.opacity = '1'; }, 180);
      }
    }
  });

  /* Sanftes Einblenden: nur Elemente unterhalb des sichtbaren Bereichs, kein Layout-Sprung */
  function initReveal() {
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var items = document.querySelectorAll('.kel-reveal');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) {
          var el = en.target;
          el.style.transitionDelay = (el.dataset.kelDelay || 0) + 'ms';
          el.classList.remove('is-pending');
          setTimeout(function () { el.style.transitionDelay = ''; }, 900);
          io.unobserve(el);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    items.forEach(function (el) {
      if (el.getBoundingClientRect().top > window.innerHeight) {
        el.classList.add('is-pending');
        io.observe(el);
      }
    });
  }

  /* Filterleiste klebt unter der Kopfzeile. Das Theme macht die Kopfzeile erst beim Scrollen
     klebend, darum wird die Höhe beim Scrollen laufend nachgeführt. */
  var stickyQueued = false, lastSticky = -1;
  function setSticky() {
    stickyQueued = false;
    var h = 0;
    document.querySelectorAll('.shopify-section-group-header-group, sticky-header').forEach(function (el) {
      var pos = getComputedStyle(el).position;
      if (pos !== 'sticky' && pos !== 'fixed') return;
      var r = el.getBoundingClientRect();
      if (r.bottom > 0 && r.top <= 1) h = Math.max(h, r.bottom);
    });
    h = Math.min(Math.round(h), 180);
    if (h !== lastSticky) {
      lastSticky = h;
      document.documentElement.style.setProperty('--kel-sticky', h + 'px');
    }
  }
  function queueSticky() {
    if (stickyQueued) return;
    stickyQueued = true;
    requestAnimationFrame(setSticky);
  }

  function start() {
    initReveal();
    setSticky();
    if (document.querySelector('.kel-filterbar')) {
      window.addEventListener('scroll', queueSticky, { passive: true });
      window.addEventListener('resize', queueSticky);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else { start(); }
})();
